import React, { createContext, useContext, useState, useCallback } from 'react';
import { t as translate } from '../utils/i18n';

const LangContext = createContext();

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('gglancc_lang') || 'zh-CN');

  const switchLang = useCallback((code) => {
    localStorage.setItem('gglancc_lang', code);
    setLang(code);
  }, []);

  // 'en' param for API calls, undefined for zh-CN (default)
  const langParam = lang === 'zh-CN' ? undefined : 'en';

  // Translation helper
  const t = useCallback((key) => translate(lang, key), [lang]);

  return (
    <LangContext.Provider value={{ lang, langParam, switchLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
